var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0512 4.89768H7.29395C5.79093 4.89768 5.03942 4.89768 4.46534 5.19019C3.96036 5.44748 3.54981 5.85804 3.29251 6.36301C3 6.93709 3 7.68861 3 9.19163V16.706C3 18.2091 3 18.9606 3.29251 19.5347C3.54981 20.0396 3.96036 20.4502 4.46534 20.7075C5.03942 21 5.79093 21 7.29395 21H14.8084C16.3114 21 17.0629 21 17.637 20.7075C18.142 20.4502 18.5525 20.0396 18.8098 19.5347C19.1023 18.9606 19.1023 18.2091 19.1023 16.706V12.9488M8.36742 15.6326H9.86542C10.303 15.6326 10.5218 15.6326 10.7277 15.5831C10.9103 15.5393 11.0848 15.467 11.2449 15.3689C11.4255 15.2583 11.5802 15.1035 11.8896 14.7941L20.4442 6.23954C21.1853 5.49845 21.1853 4.29691 20.4442 3.55582C19.7031 2.81473 18.5016 2.81473 17.7605 3.55582L9.20587 12.1104C8.89643 12.4198 8.74171 12.5745 8.63107 12.7551C8.53297 12.9152 8.46068 13.0897 8.41685 13.2723C8.36742 13.4782 8.36742 13.697 8.36742 14.1346V15.6326Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit05);
export default __webpack_public_path__ + "static/media/edit-05.18c67437da9ffe6a4ab503895de26996.svg";
export { ForwardRef as ReactComponent };